<template>
  <v-fade-transition>
    <div v-if="loading" class="overlay-loading" :style="style">
      <v-progress-circular
        :size="50"
        :width="5"
        color="accent"
        indeterminate />

        <slot></slot>
    </div>
  </v-fade-transition>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 50
    },
    width: {
      type: Number,
      default: 5
    },
    fixed: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: 'rgba(255,255,255,0.7)'
    }
  },

  computed: {
    style() {
      return {
        'background-color': this.backgroundColor,
        'position': this.fixed ? 'fixed' : 'absolute'
      };
    }
  }
};
</script>

<style lang="stylus" scoped>
.overlay-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
